export class RazorpayXEmployeeModel {
    organization_id: number;
    user_id: number;
    razorpay_employee_id: number;
}
